"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _baseService = _interopRequireDefault(require("@/config/base-service"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var AccessControlService = /*#__PURE__*/function (_BaseService) {
  function AccessControlService() {
    _classCallCheck(this, AccessControlService);
    return _callSuper(this, AccessControlService, ["access"]);
  }

  // Pages
  _inherits(AccessControlService, _BaseService);
  return _createClass(AccessControlService, [{
    key: "fecthPagesSidebarMenu",
    value: function fecthPagesSidebarMenu(params) {
      return this.get("pages", {
        params: params
      });
    }
  }, {
    key: "createPage",
    value: function createPage(data) {
      return this.post(data, "pages");
    }
  }, {
    key: "updatePage",
    value: function updatePage(data) {
      var id = data._id;
      delete data._id;
      return this.put(data, "pages/".concat(id));
    }
  }, {
    key: "fetchAccessPage",
    value: function fetchAccessPage(id) {
      return this.get("pages/".concat(id));
    }

    // Access Groups
  }, {
    key: "fecthAccessGroupsList",
    value: function fecthAccessGroupsList(params) {
      return this.get("groups", {
        params: params
      });
    }
  }, {
    key: "createAccessGroup",
    value: function createAccessGroup(data) {
      return this.post(data, "groups");
    }
  }, {
    key: "updateAccessGroup",
    value: function updateAccessGroup(data) {
      var id = data._id;
      delete data._id;
      return this.put(data, "groups/".concat(id));
    }
  }, {
    key: "fetchAccessGroup",
    value: function fetchAccessGroup(id) {
      return this.get("groups/".concat(id));
    }
  }, {
    key: "fetchPagesLinkGroup",
    value: function fetchPagesLinkGroup(codGroup) {
      return this.get("groups-links?codGroup=".concat(codGroup));
    }
  }, {
    key: "fetchGroupLinkPage",
    value: function fetchGroupLinkPage(codPage) {
      return this.get("pages-links?codPage=".concat(codPage));
    }
  }, {
    key: "addPageToAccessGroup",
    value: function addPageToAccessGroup(data) {
      return this.post(data, "groups-links");
    }
  }, {
    key: "removePageToAccessGroup",
    value: function removePageToAccessGroup(data) {
      return this.delete("groups-links?codPage=".concat(data.codPage, "&codGroup=").concat(data.codGroup));
    }
  }]);
}(_baseService.default);
var _default = exports.default = new AccessControlService();